import React from "react";
interface IProps {
  onClick ?: () => void
}
const SupplierBatchIcon = ({onClick} :IProps) => {
  return (
<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="0.5" width="13" height="13" rx="1" fill="#565D63"/>
<line x1="0.5" y1="2.5" x2="0.499999" y2="14.5" stroke="#1B242C" stroke-opacity="0.74"/>
<line y1="15" x2="12" y2="15" stroke="#1B242C" stroke-opacity="0.74"/>
<path d="M11 7.35714H8.85714V9.5H8.14286V7.35714H6V6.64286H8.14286V4.5H8.85714V6.64286H11V7.35714Z" fill="white"/>
</svg>

  );
};

export default SupplierBatchIcon;
